import * as types from "../mutations"

export default {
    namespaced: true,

    state: {
        sliders: []
    },

    actions: {
        fetchAll({ commit }) {
            return window.axios.get('/sliders').then(res => {
                commit(types.SLIDERS_STORE, res.data)
                return res.data
            }).catch(() => { })
        }
    },

    mutations: {
        [types.SLIDERS_STORE](state, sliders) {
            state.sliders = sliders
        }
    }
}